module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular.73e1c157.eot";